// authSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

//* Define the shape of the AuthState
interface ProfileState {
  name: string,
  gender: string,
  bodyType: string,
  ethnicity: string,
  workspace: string,
  jobtitle: any,
  school: string,
  language: any
  seeking:string,
  relationship:string,
  drinking:string,
  smoking:string,
  experienceArray:any,
  height:string,
}

//* Set the initial state for the auth slice
const initialState: ProfileState = {
  name: '',
  gender: '',
  bodyType: '',
  ethnicity: '',
  workspace: '',
  jobtitle: '',
  school: '',
  language: null,
  seeking:'',
  relationship:'',
  drinking:'',
  smoking:'',
  experienceArray:null,
  height:'',
};

//* Create a slice using createSlice
const profileSlice = createSlice({
  name: 'profile', //* The name of the slice
  initialState, //* The initial state
  reducers: {
    //* Define a reducer to handle the setAuthenticated action
    setName: (state, action: PayloadAction<any>) => {
      state.name = action.payload
    },
    setGenderHook: (state, action: PayloadAction<any>) => {
      state.gender = action.payload
    },
    setBodyType: (state, action: PayloadAction<any>) => {
      state.bodyType = action.payload
    },
    setEthnicityHook: (state, action: PayloadAction<any>) => {
      state.ethnicity = action.payload
    },
    setWorkspaceHook: (state, action: PayloadAction<any>) => {
      state.workspace = action.payload
    },
    setJobtitleHook: (state, action: PayloadAction<any>) => {
      state.jobtitle = action.payload
    },
    setSchoolHook: (state, action: PayloadAction<any>) => {
      state.school = action.payload
    },
    setLanguageHook: (state, action: PayloadAction<any>) => {
      state.language = action.payload
    },
    setSeekingHook: (state, action: PayloadAction<any>) => {
      state.seeking = action.payload
    },
    setRelationshipHook:(state, action: PayloadAction<any>) => {
      state.relationship = action.payload
    },
    setDrinkingHook:(state, action: PayloadAction<any>) => {
      state.drinking = action.payload
    },
    setSmokingHook:(state, action: PayloadAction<any>) => {
      state.smoking = action.payload
    },
    setExperienceHook:(state, action: PayloadAction<any>) => {
      state.experienceArray = action.payload
    },
    setHeightHook:(state, action: PayloadAction<any>) => {
      state.height = action.payload
    },



  },
});

//* Extract the action creator(s) and reducer from the slice
export const { setName, setGenderHook, setBodyType, setEthnicityHook, setWorkspaceHook, setJobtitleHook, setSchoolHook ,setLanguageHook,setSeekingHook,setRelationshipHook,setDrinkingHook,setSmokingHook,setExperienceHook,setHeightHook } = profileSlice.actions;

//* Export the entire slice, which includes the reducer
export default profileSlice.reducer;
